import { supabase, getCurrentUser } from './supabase';
import type { JobApplication, JobNote } from '../types';

const TABLE = 'job_applications';

export async function fetchJobApplications(): Promise<JobApplication[]> {
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .order('updated_at', { ascending: false });
  if (error) throw error;
  return data as JobApplication[];
}

export async function createJobApplication(
  app: Omit<JobApplication, 'id' | 'user_id' | 'created_at' | 'updated_at'>
): Promise<JobApplication> {
  const user = await getCurrentUser();
  if (!user) throw new Error('User not authenticated');

  const { data, error } = await supabase
    .from(TABLE)
    .insert({ ...app, user_id: user.id })
    .select()
    .single();
  if (error) throw error;
  return data as JobApplication;
}

export async function updateJobApplication(
  id: string,
  updates: Partial<Omit<JobApplication, 'id' | 'user_id' | 'created_at' | 'updated_at'>>
): Promise<JobApplication> {
  const { data, error } = await supabase
    .from(TABLE)
    .update(updates)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data as JobApplication;
}

export async function deleteJobApplication(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);
  if (error) throw error;
}

export async function addJobNote(id: string, text: string): Promise<JobApplication> {
  const { data: existing, error: fetchErr } = await supabase
    .from(TABLE)
    .select('notes')
    .eq('id', id)
    .single();
  if (fetchErr) throw fetchErr;

  const notes: JobNote[] = existing.notes || [];
  notes.push({ text, date: new Date().toISOString() });

  const { data, error } = await supabase
    .from(TABLE)
    .update({ notes })
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data as JobApplication;
}
